import { AnimatedNumber } from './AnimatedNumber'

interface Props {
  label: string
  value: number
  /** The same figure for the previous period, which draws the trend arrow. */
  prev?: number
  /** A single emoji flag, e.g. 👑 for first ascents. */
  accent?: string
  size?: 'md' | 'lg'
}

function TrendArrow({ current, prev }: { current: number; prev: number }) {
  if (current > prev) return <span className="text-xs font-bold text-success">↑</span>
  if (current < prev) return <span className="text-xs font-bold text-danger">↓</span>
  return <span className="text-xs font-bold text-foreground/25">—</span>
}

/**
 * One number and what it means.
 *
 * Promoted out of ProgressPage, where it was private, because the dashboard
 * and the competition screens all want the same thing.
 */
export function StatTile({ label, value, prev, accent, size = 'md' }: Props) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-baseline gap-1.5">
        <AnimatedNumber
          value={value}
          className={`font-semibold leading-none ${size === 'lg' ? 'text-4xl' : 'text-3xl'}`}
        />
        {accent && (
          <span aria-hidden className="text-base leading-none">
            {accent}
          </span>
        )}
        {prev !== undefined && <TrendArrow current={value} prev={prev} />}
      </div>
      <span className="text-sm text-foreground/45">{label}</span>
    </div>
  )
}
